/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as AdminAgentTurnLimitRouteImport } from './routes/admin/agent-turn-limit'
import { Route as AdminAgentsRouteImport } from './routes/admin/agents'
import { Route as AdminApiDocsRouteImport } from './routes/admin/api-docs'
import { Route as AdminAuditRouteImport } from './routes/admin/audit'
import { Route as AdminBuiltinToolsRouteImport } from './routes/admin/builtin-tools'
import { Route as AdminFeatureTogglesRouteImport } from './routes/admin/feature-toggles'
import { Route as AdminFeedbackRouteImport } from './routes/admin/feedback'
import { Route as AdminFileUploadsRouteImport } from './routes/admin/file-uploads'
import { Route as AdminKnowledgeBasesRouteImport } from './routes/admin/knowledge-bases'
import { Route as AdminMcpServersRouteImport } from './routes/admin/mcp-servers'
import { Route as AdminMicrosoftIntegrationRouteImport } from './routes/admin/microsoft-integration'
import { Route as AdminModelAliasesRouteImport } from './routes/admin/model-aliases'
import { Route as AdminModelRoutingRouteImport } from './routes/admin/model-routing'
import { Route as AdminOauthProvidersRouteImport } from './routes/admin/oauth-providers'
import { Route as AdminObservabilityRouteImport } from './routes/admin/observability'
import { Route as AdminPermissionSimulatorRouteImport } from './routes/admin/permission-simulator'
import { Route as AdminRetentionRouteImport } from './routes/admin/retention'
import { Route as AdminRolesRouteImport } from './routes/admin/roles'
import { Route as AdminServicePrincipalsRouteImport } from './routes/admin/service-principals'
import { Route as AdminSkillsRouteImport } from './routes/admin/skills'
import { Route as AdminSystemPromptsRouteImport } from './routes/admin/system-prompts'
import { Route as AdminToolApprovalRouteImport } from './routes/admin/tool-approval'
import { Route as AdminUsageRouteImport } from './routes/admin/usage'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminVoiceRouteImport } from './routes/admin/voice'
import { Route as ArtifactsArtifactIdRouteImport } from './routes/artifacts/$artifactId'
import { Route as SettingsApiKeysRouteImport } from './routes/settings/api-keys'
import { Route as SettingsIntegrationsRouteImport } from './routes/settings/integrations'
import { Route as SettingsSkillsRouteImport } from './routes/settings/skills'
import { Route as SharedShareIdRouteImport } from './routes/shared/$shareId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAgentTurnLimitRoute = AdminAgentTurnLimitRouteImport.update({
  id: '/agent-turn-limit',
  path: '/agent-turn-limit',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAgentsRoute = AdminAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminApiDocsRoute = AdminApiDocsRouteImport.update({
  id: '/api-docs',
  path: '/api-docs',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminBuiltinToolsRoute = AdminBuiltinToolsRouteImport.update({
  id: '/builtin-tools',
  path: '/builtin-tools',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFeatureTogglesRoute = AdminFeatureTogglesRouteImport.update({
  id: '/feature-toggles',
  path: '/feature-toggles',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFeedbackRoute = AdminFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFileUploadsRoute = AdminFileUploadsRouteImport.update({
  id: '/file-uploads',
  path: '/file-uploads',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminKnowledgeBasesRoute = AdminKnowledgeBasesRouteImport.update({
  id: '/knowledge-bases',
  path: '/knowledge-bases',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMcpServersRoute = AdminMcpServersRouteImport.update({
  id: '/mcp-servers',
  path: '/mcp-servers',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMicrosoftIntegrationRoute =
  AdminMicrosoftIntegrationRouteImport.update({
    id: '/microsoft-integration',
    path: '/microsoft-integration',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminModelAliasesRoute = AdminModelAliasesRouteImport.update({
  id: '/model-aliases',
  path: '/model-aliases',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminModelRoutingRoute = AdminModelRoutingRouteImport.update({
  id: '/model-routing',
  path: '/model-routing',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminOauthProvidersRoute = AdminOauthProvidersRouteImport.update({
  id: '/oauth-providers',
  path: '/oauth-providers',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminObservabilityRoute = AdminObservabilityRouteImport.update({
  id: '/observability',
  path: '/observability',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPermissionSimulatorRoute =
  AdminPermissionSimulatorRouteImport.update({
    id: '/permission-simulator',
    path: '/permission-simulator',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminRetentionRoute = AdminRetentionRouteImport.update({
  id: '/retention',
  path: '/retention',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminRolesRoute = AdminRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminServicePrincipalsRoute = AdminServicePrincipalsRouteImport.update({
  id: '/service-principals',
  path: '/service-principals',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSkillsRoute = AdminSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSystemPromptsRoute = AdminSystemPromptsRouteImport.update({
  id: '/system-prompts',
  path: '/system-prompts',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminToolApprovalRoute = AdminToolApprovalRouteImport.update({
  id: '/tool-approval',
  path: '/tool-approval',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsageRoute = AdminUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminVoiceRoute = AdminVoiceRouteImport.update({
  id: '/voice',
  path: '/voice',
  getParentRoute: () => AdminRouteRoute,
} as any)
const ArtifactsArtifactIdRoute = ArtifactsArtifactIdRouteImport.update({
  id: '/artifacts/$artifactId',
  path: '/artifacts/$artifactId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsApiKeysRoute = SettingsApiKeysRouteImport.update({
  id: '/settings/api-keys',
  path: '/settings/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIntegrationsRoute = SettingsIntegrationsRouteImport.update({
  id: '/settings/integrations',
  path: '/settings/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSkillsRoute = SettingsSkillsRouteImport.update({
  id: '/settings/skills',
  path: '/settings/skills',
  getParentRoute: () => rootRouteImport,
} as any)
const SharedShareIdRoute = SharedShareIdRouteImport.update({
  id: '/shared/$shareId',
  path: '/shared/$shareId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/setup': typeof SetupRoute
  '/admin/agent-turn-limit': typeof AdminAgentTurnLimitRoute
  '/admin/agents': typeof AdminAgentsRoute
  '/admin/api-docs': typeof AdminApiDocsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/builtin-tools': typeof AdminBuiltinToolsRoute
  '/admin/feature-toggles': typeof AdminFeatureTogglesRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/file-uploads': typeof AdminFileUploadsRoute
  '/admin/knowledge-bases': typeof AdminKnowledgeBasesRoute
  '/admin/mcp-servers': typeof AdminMcpServersRoute
  '/admin/microsoft-integration': typeof AdminMicrosoftIntegrationRoute
  '/admin/model-aliases': typeof AdminModelAliasesRoute
  '/admin/model-routing': typeof AdminModelRoutingRoute
  '/admin/oauth-providers': typeof AdminOauthProvidersRoute
  '/admin/observability': typeof AdminObservabilityRoute
  '/admin/permission-simulator': typeof AdminPermissionSimulatorRoute
  '/admin/retention': typeof AdminRetentionRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/service-principals': typeof AdminServicePrincipalsRoute
  '/admin/skills': typeof AdminSkillsRoute
  '/admin/system-prompts': typeof AdminSystemPromptsRoute
  '/admin/tool-approval': typeof AdminToolApprovalRoute
  '/admin/usage': typeof AdminUsageRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/voice': typeof AdminVoiceRoute
  '/artifacts/$artifactId': typeof ArtifactsArtifactIdRoute
  '/settings/api-keys': typeof SettingsApiKeysRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/skills': typeof SettingsSkillsRoute
  '/shared/$shareId': typeof SharedShareIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/setup': typeof SetupRoute
  '/admin/agent-turn-limit': typeof AdminAgentTurnLimitRoute
  '/admin/agents': typeof AdminAgentsRoute
  '/admin/api-docs': typeof AdminApiDocsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/builtin-tools': typeof AdminBuiltinToolsRoute
  '/admin/feature-toggles': typeof AdminFeatureTogglesRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/file-uploads': typeof AdminFileUploadsRoute
  '/admin/knowledge-bases': typeof AdminKnowledgeBasesRoute
  '/admin/mcp-servers': typeof AdminMcpServersRoute
  '/admin/microsoft-integration': typeof AdminMicrosoftIntegrationRoute
  '/admin/model-aliases': typeof AdminModelAliasesRoute
  '/admin/model-routing': typeof AdminModelRoutingRoute
  '/admin/oauth-providers': typeof AdminOauthProvidersRoute
  '/admin/observability': typeof AdminObservabilityRoute
  '/admin/permission-simulator': typeof AdminPermissionSimulatorRoute
  '/admin/retention': typeof AdminRetentionRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/service-principals': typeof AdminServicePrincipalsRoute
  '/admin/skills': typeof AdminSkillsRoute
  '/admin/system-prompts': typeof AdminSystemPromptsRoute
  '/admin/tool-approval': typeof AdminToolApprovalRoute
  '/admin/usage': typeof AdminUsageRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/voice': typeof AdminVoiceRoute
  '/artifacts/$artifactId': typeof ArtifactsArtifactIdRoute
  '/settings/api-keys': typeof SettingsApiKeysRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/skills': typeof SettingsSkillsRoute
  '/shared/$shareId': typeof SharedShareIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/setup': typeof SetupRoute
  '/admin/agent-turn-limit': typeof AdminAgentTurnLimitRoute
  '/admin/agents': typeof AdminAgentsRoute
  '/admin/api-docs': typeof AdminApiDocsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/builtin-tools': typeof AdminBuiltinToolsRoute
  '/admin/feature-toggles': typeof AdminFeatureTogglesRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/file-uploads': typeof AdminFileUploadsRoute
  '/admin/knowledge-bases': typeof AdminKnowledgeBasesRoute
  '/admin/mcp-servers': typeof AdminMcpServersRoute
  '/admin/microsoft-integration': typeof AdminMicrosoftIntegrationRoute
  '/admin/model-aliases': typeof AdminModelAliasesRoute
  '/admin/model-routing': typeof AdminModelRoutingRoute
  '/admin/oauth-providers': typeof AdminOauthProvidersRoute
  '/admin/observability': typeof AdminObservabilityRoute
  '/admin/permission-simulator': typeof AdminPermissionSimulatorRoute
  '/admin/retention': typeof AdminRetentionRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/service-principals': typeof AdminServicePrincipalsRoute
  '/admin/skills': typeof AdminSkillsRoute
  '/admin/system-prompts': typeof AdminSystemPromptsRoute
  '/admin/tool-approval': typeof AdminToolApprovalRoute
  '/admin/usage': typeof AdminUsageRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/voice': typeof AdminVoiceRoute
  '/artifacts/$artifactId': typeof ArtifactsArtifactIdRoute
  '/settings/api-keys': typeof SettingsApiKeysRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/skills': typeof SettingsSkillsRoute
  '/shared/$shareId': typeof SharedShareIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/setup'
    | '/admin/agent-turn-limit'
    | '/admin/agents'
    | '/admin/api-docs'
    | '/admin/audit'
    | '/admin/builtin-tools'
    | '/admin/feature-toggles'
    | '/admin/feedback'
    | '/admin/file-uploads'
    | '/admin/knowledge-bases'
    | '/admin/mcp-servers'
    | '/admin/microsoft-integration'
    | '/admin/model-aliases'
    | '/admin/model-routing'
    | '/admin/oauth-providers'
    | '/admin/observability'
    | '/admin/permission-simulator'
    | '/admin/retention'
    | '/admin/roles'
    | '/admin/service-principals'
    | '/admin/skills'
    | '/admin/system-prompts'
    | '/admin/tool-approval'
    | '/admin/usage'
    | '/admin/users'
    | '/admin/voice'
    | '/artifacts/$artifactId'
    | '/settings/api-keys'
    | '/settings/integrations'
    | '/settings/skills'
    | '/shared/$shareId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/setup'
    | '/admin/agent-turn-limit'
    | '/admin/agents'
    | '/admin/api-docs'
    | '/admin/audit'
    | '/admin/builtin-tools'
    | '/admin/feature-toggles'
    | '/admin/feedback'
    | '/admin/file-uploads'
    | '/admin/knowledge-bases'
    | '/admin/mcp-servers'
    | '/admin/microsoft-integration'
    | '/admin/model-aliases'
    | '/admin/model-routing'
    | '/admin/oauth-providers'
    | '/admin/observability'
    | '/admin/permission-simulator'
    | '/admin/retention'
    | '/admin/roles'
    | '/admin/service-principals'
    | '/admin/skills'
    | '/admin/system-prompts'
    | '/admin/tool-approval'
    | '/admin/usage'
    | '/admin/users'
    | '/admin/voice'
    | '/artifacts/$artifactId'
    | '/settings/api-keys'
    | '/settings/integrations'
    | '/settings/skills'
    | '/shared/$shareId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/setup'
    | '/admin/agent-turn-limit'
    | '/admin/agents'
    | '/admin/api-docs'
    | '/admin/audit'
    | '/admin/builtin-tools'
    | '/admin/feature-toggles'
    | '/admin/feedback'
    | '/admin/file-uploads'
    | '/admin/knowledge-bases'
    | '/admin/mcp-servers'
    | '/admin/microsoft-integration'
    | '/admin/model-aliases'
    | '/admin/model-routing'
    | '/admin/oauth-providers'
    | '/admin/observability'
    | '/admin/permission-simulator'
    | '/admin/retention'
    | '/admin/roles'
    | '/admin/service-principals'
    | '/admin/skills'
    | '/admin/system-prompts'
    | '/admin/tool-approval'
    | '/admin/usage'
    | '/admin/users'
    | '/admin/voice'
    | '/artifacts/$artifactId'
    | '/settings/api-keys'
    | '/settings/integrations'
    | '/settings/skills'
    | '/shared/$shareId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  SetupRoute: typeof SetupRoute
  ArtifactsArtifactIdRoute: typeof ArtifactsArtifactIdRoute
  SettingsApiKeysRoute: typeof SettingsApiKeysRoute
  SettingsIntegrationsRoute: typeof SettingsIntegrationsRoute
  SettingsSkillsRoute: typeof SettingsSkillsRoute
  SharedShareIdRoute: typeof SharedShareIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/agent-turn-limit': {
      id: '/admin/agent-turn-limit'
      path: '/agent-turn-limit'
      fullPath: '/admin/agent-turn-limit'
      preLoaderRoute: typeof AdminAgentTurnLimitRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/agents': {
      id: '/admin/agents'
      path: '/agents'
      fullPath: '/admin/agents'
      preLoaderRoute: typeof AdminAgentsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/api-docs': {
      id: '/admin/api-docs'
      path: '/api-docs'
      fullPath: '/admin/api-docs'
      preLoaderRoute: typeof AdminApiDocsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/builtin-tools': {
      id: '/admin/builtin-tools'
      path: '/builtin-tools'
      fullPath: '/admin/builtin-tools'
      preLoaderRoute: typeof AdminBuiltinToolsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/feature-toggles': {
      id: '/admin/feature-toggles'
      path: '/feature-toggles'
      fullPath: '/admin/feature-toggles'
      preLoaderRoute: typeof AdminFeatureTogglesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/feedback': {
      id: '/admin/feedback'
      path: '/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof AdminFeedbackRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/file-uploads': {
      id: '/admin/file-uploads'
      path: '/file-uploads'
      fullPath: '/admin/file-uploads'
      preLoaderRoute: typeof AdminFileUploadsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/knowledge-bases': {
      id: '/admin/knowledge-bases'
      path: '/knowledge-bases'
      fullPath: '/admin/knowledge-bases'
      preLoaderRoute: typeof AdminKnowledgeBasesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/mcp-servers': {
      id: '/admin/mcp-servers'
      path: '/mcp-servers'
      fullPath: '/admin/mcp-servers'
      preLoaderRoute: typeof AdminMcpServersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/microsoft-integration': {
      id: '/admin/microsoft-integration'
      path: '/microsoft-integration'
      fullPath: '/admin/microsoft-integration'
      preLoaderRoute: typeof AdminMicrosoftIntegrationRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/model-aliases': {
      id: '/admin/model-aliases'
      path: '/model-aliases'
      fullPath: '/admin/model-aliases'
      preLoaderRoute: typeof AdminModelAliasesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/model-routing': {
      id: '/admin/model-routing'
      path: '/model-routing'
      fullPath: '/admin/model-routing'
      preLoaderRoute: typeof AdminModelRoutingRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/oauth-providers': {
      id: '/admin/oauth-providers'
      path: '/oauth-providers'
      fullPath: '/admin/oauth-providers'
      preLoaderRoute: typeof AdminOauthProvidersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/observability': {
      id: '/admin/observability'
      path: '/observability'
      fullPath: '/admin/observability'
      preLoaderRoute: typeof AdminObservabilityRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/permission-simulator': {
      id: '/admin/permission-simulator'
      path: '/permission-simulator'
      fullPath: '/admin/permission-simulator'
      preLoaderRoute: typeof AdminPermissionSimulatorRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/retention': {
      id: '/admin/retention'
      path: '/retention'
      fullPath: '/admin/retention'
      preLoaderRoute: typeof AdminRetentionRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/roles': {
      id: '/admin/roles'
      path: '/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AdminRolesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/service-principals': {
      id: '/admin/service-principals'
      path: '/service-principals'
      fullPath: '/admin/service-principals'
      preLoaderRoute: typeof AdminServicePrincipalsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/skills': {
      id: '/admin/skills'
      path: '/skills'
      fullPath: '/admin/skills'
      preLoaderRoute: typeof AdminSkillsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/system-prompts': {
      id: '/admin/system-prompts'
      path: '/system-prompts'
      fullPath: '/admin/system-prompts'
      preLoaderRoute: typeof AdminSystemPromptsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tool-approval': {
      id: '/admin/tool-approval'
      path: '/tool-approval'
      fullPath: '/admin/tool-approval'
      preLoaderRoute: typeof AdminToolApprovalRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/usage': {
      id: '/admin/usage'
      path: '/usage'
      fullPath: '/admin/usage'
      preLoaderRoute: typeof AdminUsageRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/voice': {
      id: '/admin/voice'
      path: '/voice'
      fullPath: '/admin/voice'
      preLoaderRoute: typeof AdminVoiceRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/artifacts/$artifactId': {
      id: '/artifacts/$artifactId'
      path: '/artifacts/$artifactId'
      fullPath: '/artifacts/$artifactId'
      preLoaderRoute: typeof ArtifactsArtifactIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/api-keys': {
      id: '/settings/api-keys'
      path: '/settings/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof SettingsApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/integrations': {
      id: '/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof SettingsIntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/skills': {
      id: '/settings/skills'
      path: '/settings/skills'
      fullPath: '/settings/skills'
      preLoaderRoute: typeof SettingsSkillsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared/$shareId': {
      id: '/shared/$shareId'
      path: '/shared/$shareId'
      fullPath: '/shared/$shareId'
      preLoaderRoute: typeof SharedShareIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteRouteChildren {
  AdminAgentTurnLimitRoute: typeof AdminAgentTurnLimitRoute
  AdminAgentsRoute: typeof AdminAgentsRoute
  AdminApiDocsRoute: typeof AdminApiDocsRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminBuiltinToolsRoute: typeof AdminBuiltinToolsRoute
  AdminFeatureTogglesRoute: typeof AdminFeatureTogglesRoute
  AdminFeedbackRoute: typeof AdminFeedbackRoute
  AdminFileUploadsRoute: typeof AdminFileUploadsRoute
  AdminKnowledgeBasesRoute: typeof AdminKnowledgeBasesRoute
  AdminMcpServersRoute: typeof AdminMcpServersRoute
  AdminMicrosoftIntegrationRoute: typeof AdminMicrosoftIntegrationRoute
  AdminModelAliasesRoute: typeof AdminModelAliasesRoute
  AdminModelRoutingRoute: typeof AdminModelRoutingRoute
  AdminOauthProvidersRoute: typeof AdminOauthProvidersRoute
  AdminObservabilityRoute: typeof AdminObservabilityRoute
  AdminPermissionSimulatorRoute: typeof AdminPermissionSimulatorRoute
  AdminRetentionRoute: typeof AdminRetentionRoute
  AdminRolesRoute: typeof AdminRolesRoute
  AdminServicePrincipalsRoute: typeof AdminServicePrincipalsRoute
  AdminSkillsRoute: typeof AdminSkillsRoute
  AdminSystemPromptsRoute: typeof AdminSystemPromptsRoute
  AdminToolApprovalRoute: typeof AdminToolApprovalRoute
  AdminUsageRoute: typeof AdminUsageRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminVoiceRoute: typeof AdminVoiceRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAgentTurnLimitRoute: AdminAgentTurnLimitRoute,
  AdminAgentsRoute: AdminAgentsRoute,
  AdminApiDocsRoute: AdminApiDocsRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminBuiltinToolsRoute: AdminBuiltinToolsRoute,
  AdminFeatureTogglesRoute: AdminFeatureTogglesRoute,
  AdminFeedbackRoute: AdminFeedbackRoute,
  AdminFileUploadsRoute: AdminFileUploadsRoute,
  AdminKnowledgeBasesRoute: AdminKnowledgeBasesRoute,
  AdminMcpServersRoute: AdminMcpServersRoute,
  AdminMicrosoftIntegrationRoute: AdminMicrosoftIntegrationRoute,
  AdminModelAliasesRoute: AdminModelAliasesRoute,
  AdminModelRoutingRoute: AdminModelRoutingRoute,
  AdminOauthProvidersRoute: AdminOauthProvidersRoute,
  AdminObservabilityRoute: AdminObservabilityRoute,
  AdminPermissionSimulatorRoute: AdminPermissionSimulatorRoute,
  AdminRetentionRoute: AdminRetentionRoute,
  AdminRolesRoute: AdminRolesRoute,
  AdminServicePrincipalsRoute: AdminServicePrincipalsRoute,
  AdminSkillsRoute: AdminSkillsRoute,
  AdminSystemPromptsRoute: AdminSystemPromptsRoute,
  AdminToolApprovalRoute: AdminToolApprovalRoute,
  AdminUsageRoute: AdminUsageRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminVoiceRoute: AdminVoiceRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  SetupRoute: SetupRoute,
  ArtifactsArtifactIdRoute: ArtifactsArtifactIdRoute,
  SettingsApiKeysRoute: SettingsApiKeysRoute,
  SettingsIntegrationsRoute: SettingsIntegrationsRoute,
  SettingsSkillsRoute: SettingsSkillsRoute,
  SharedShareIdRoute: SharedShareIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
